import { Component, Inject } from '@angular/core';
import { Color, Icons, Modal, ModalServiceToken } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'remove-document-modal',
    templateUrl: 'remove-document-modal.html'
})
export class RemoveDocumentModal {
    public modal: Modal;
    public icons = Icons;
    public color = Color;
    public isSubmitting = false;

    constructor(@Inject(ModalServiceToken) public modalService: ModalService) {
        this.modal = this.modalService.modal;
    }

    public confirmModal(): void {
        this.isSubmitting = true;
        this.modal.onOkClick();
    }
}
